<template>
  <div class="contents">
    <div class="container-fluid">
      <InvoicePageHeader title="Pengaturan Invoice" />

      <div class="row">
        <div class="col-lg-8">
          <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <div class="inv-settings-section">
              <h6><i class="fas fa-building text-primary mr-2"></i> Branding invoice</h6>
              <div class="form-group">
                <label class="inv-form-label">Nama perusahaan / brand</label>
                <input v-model="form.company_name" class="form-control" placeholder="Tampil di PDF & halaman public">
              </div>
              <div class="form-group">
                <label class="inv-form-label">Alamat</label>
                <textarea v-model="form.company_address" class="form-control" rows="2" placeholder="Alamat lengkap"></textarea>
              </div>
              <div class="form-group mb-0">
                <label class="inv-form-label">Telepon</label>
                <input v-model="form.company_phone" class="form-control" placeholder="Nomor kontak">
              </div>
            </div>

            <div class="inv-settings-section">
              <h6><i class="fas fa-bell text-primary mr-2"></i> Template notifikasi</h6>
              <p class="inv-template-hint mb-3">
                Pesan saat kirim invoice via WhatsApp &amp; email. Kosongkan isian template = pakai desain bawaan StarSender.
                Klik shortcode untuk sisipkan ke kursor.
              </p>

              <div class="inv-notify-tabs">
                <button type="button" class="inv-notify-tabs__btn" :class="{ 'inv-notify-tabs__btn--active': notifyChannel === 'wa' }" @click="notifyChannel = 'wa'; activeShortcodeTarget = 'wa'">
                  <i class="fab fa-whatsapp text-success mr-1"></i> WhatsApp
                </button>
                <button type="button" class="inv-notify-tabs__btn" :class="{ 'inv-notify-tabs__btn--active': notifyChannel === 'email' }" @click="notifyChannel = 'email'; activeShortcodeTarget = 'html'">
                  <i class="fas fa-envelope mr-1"></i> Email (HTML)
                </button>
              </div>

              <div class="inv-shortcodes">
                <button
                  v-for="sc in shortcodes"
                  :key="sc.code"
                  type="button"
                  class="inv-shortcode-chip"
                  :title="sc.description || sc.label"
                  @click="insertShortcode(activeShortcodeTarget, sc.code)"
                >
                  <code>{{ sc.code }}</code>
                </button>
              </div>

              <div v-show="notifyChannel === 'wa'">
                <div class="form-group">
                  <label class="inv-form-label">Device ID (StarSender)</label>
                  <input v-model.number="form.default_device_id" type="number" class="form-control" placeholder="ID device pengirim">
                </div>
                <div class="inv-template-toolbar">
                  <div class="inv-editor-subtabs">
                    <button type="button" class="inv-editor-subtabs__btn" :class="{ 'inv-editor-subtabs__btn--active': waMode === 'edit' }" @click="waMode = 'edit'">Edit pesan</button>
                    <button type="button" class="inv-editor-subtabs__btn" :class="{ 'inv-editor-subtabs__btn--active': waMode === 'preview' }" @click="waMode = 'preview'">Preview WA</button>
                  </div>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="resetWATemplate">Pakai template bawaan</button>
                </div>
                <textarea
                  v-show="waMode === 'edit'"
                  ref="waTemplateInput"
                  v-model="form.wa_template"
                  class="form-control"
                  rows="10"
                  placeholder="Kosong = template bawaan. Gunakan *teks* untuk bold di WhatsApp."
                  @focus="activeShortcodeTarget = 'wa'"
                ></textarea>
                <div v-show="waMode === 'preview'" class="inv-wa-phone">
                  <div class="inv-wa-phone__bar">
                    <i class="fab fa-whatsapp mr-2"></i>{{ form.company_name || 'Brand Anda' }}
                  </div>
                  <div class="inv-wa-phone__body">
                    <div class="inv-wa-bubble">
                      <div v-html="waPreviewHtml"></div>
                      <div class="inv-wa-bubble__meta">{{ previewTimeLabel }} · PDF terlampir</div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="notifyChannel === 'email'">
                <div class="form-group">
                  <label class="inv-form-label">Mailketing API Token</label>
                  <input v-model="form.mailketing_api_token" type="password" class="form-control" placeholder="Kosongkan jika tidak diubah">
                  <a href="https://api.mailketing.co.id/docs/" target="_blank" rel="noopener" class="small">Dokumentasi Mailketing</a>
                </div>
                <div class="row">
                  <div class="col-md-6 form-group">
                    <label class="inv-form-label">From email</label>
                    <input v-model="form.mailketing_from_email" class="form-control">
                  </div>
                  <div class="col-md-6 form-group">
                    <label class="inv-form-label">From name</label>
                    <input v-model="form.mailketing_from_name" class="form-control">
                  </div>
                </div>
                <div class="form-group">
                  <label class="inv-form-label">Subject email</label>
                  <input
                    ref="emailSubjectInput"
                    v-model="form.email_subject"
                    class="form-control"
                    placeholder="Kosong = subject bawaan"
                    @focus="activeShortcodeTarget = 'subject'"
                  >
                </div>
                <div class="inv-template-toolbar">
                  <div class="inv-editor-subtabs">
                    <button type="button" class="inv-editor-subtabs__btn" :class="{ 'inv-editor-subtabs__btn--active': emailMode === 'edit' }" @click="emailMode = 'edit'">Editor HTML</button>
                    <button type="button" class="inv-editor-subtabs__btn" :class="{ 'inv-editor-subtabs__btn--active': emailMode === 'preview' }" @click="emailMode = 'preview'">Preview HTML</button>
                  </div>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="resetEmailTemplate">Pakai template bawaan</button>
                </div>
                <textarea
                  v-show="emailMode === 'edit'"
                  ref="emailHtmlInput"
                  v-model="form.email_body_html"
                  class="form-control inv-html-editor"
                  spellcheck="false"
                  placeholder="HTML email — kosong = template bawaan"
                  @focus="activeShortcodeTarget = 'html'"
                ></textarea>
                <div v-show="emailMode === 'preview'" class="inv-email-preview-frame">
                  <iframe :srcdoc="emailPreviewSrcdoc" title="Preview email invoice"></iframe>
                </div>
                <div class="row align-items-end mt-3">
                  <div class="col-md-8 form-group mb-0">
                    <label class="inv-form-label">Test kirim (data contoh + template Anda)</label>
                    <input v-model="testEmail" type="email" class="form-control" placeholder="email@domain.com">
                  </div>
                  <div class="col-md-4 form-group mb-0">
                    <button type="button" class="btn btn-outline-secondary btn-block" @click="testMail">Test email</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="inv-settings-section">
              <h6><i class="fas fa-university text-primary mr-2"></i> Transfer manual (bank)</h6>
              <div class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" id="manualTransferSwitch" v-model="manualTransferBool">
                <label class="custom-control-label" for="manualTransferSwitch">
                  Tampilkan rekening di invoice manual &amp; halaman public
                </label>
              </div>
              <div v-for="(bank, idx) in form.bank_accounts" :key="'bank-' + idx" class="inv-item-row mb-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <strong class="small text-muted">Rekening {{ idx + 1 }}</strong>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    v-if="form.bank_accounts.length > 1"
                    @click="form.bank_accounts.splice(idx, 1)"
                  >
                    Hapus
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-6 form-group mb-md-2">
                    <label class="inv-form-label">Nama bank</label>
                    <input v-model="bank.bank_name" class="form-control" placeholder="BCA, Mandiri, BRI…">
                  </div>
                  <div class="col-md-6 form-group mb-md-2">
                    <label class="inv-form-label">Nomor rekening</label>
                    <input v-model="bank.bank_account_number" class="form-control" placeholder="1234567890">
                  </div>
                  <div class="col-md-12 form-group mb-0">
                    <label class="inv-form-label">Atas nama</label>
                    <input v-model="bank.bank_account_holder" class="form-control" placeholder="Nama pemilik rekening">
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-sm btn-outline-primary mb-3" @click="addBankAccount">
                <i class="fas fa-plus"></i> Tambah rekening bank
              </button>
              <div class="form-group mb-0">
                <label class="inv-form-label">Petunjuk tambahan</label>
                <textarea v-model="form.manual_transfer_notes" class="form-control" rows="3"
                  placeholder="Contoh: Konfirmasi pembayaran via WhatsApp ke 628… sertakan bukti transfer."></textarea>
              </div>
            </div>

            <div class="inv-settings-section">
              <h6><i class="fas fa-qrcode text-primary mr-2"></i> StarQRIS</h6>
              <div class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" id="starqrisSwitch" v-model="starqrisBool">
                <label class="custom-control-label" for="starqrisSwitch">Aktifkan pembayaran QRIS di invoice public</label>
              </div>
              <div class="form-group">
                <label class="inv-form-label">API Key</label>
                <input v-model="form.starqris_api_key" type="password" class="form-control" placeholder="qris_…">
              </div>
              <div class="form-group">
                <label class="inv-form-label">Webhook secret</label>
                <input v-model="form.starqris_webhook_secret" type="password" class="form-control">
              </div>
              <div class="form-group mb-2">
                <label class="inv-form-label">QRIS account ID</label>
                <input v-model="form.starqris_qris_account_id" class="form-control">
              </div>
              <p class="small text-muted mb-0">
                <i class="fas fa-info-circle"></i> Webhook URL:
                <code class="d-inline-block mt-1 user-select-all">{{ webhookUrl }}</code>
              </p>
            </div>

            <button type="button" class="btn btn-primary px-4" :disabled="saving" @click="save">
              {{ saving ? 'Menyimpan…' : 'Simpan pengaturan' }}
            </button>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="inv-panel">
            <div class="inv-panel__head"><i class="fas fa-lightbulb"></i> Tips</div>
            <div class="inv-panel__body">
              <ul class="pl-3 mb-0 text-muted small">
                <li class="mb-2">Lengkapi branding agar PDF terlihat profesional.</li>
                <li class="mb-2">Atur template WA &amp; email — preview sebelum kirim ke customer.</li>
                <li class="mb-2">Device WA harus aktif sebelum kirim invoice.</li>
                <li class="mb-2">Isi rekening bank untuk metode <b>Manual / transfer</b> pada invoice.</li>
                <li class="mb-2">StarQRIS untuk pembayaran otomatis via QRIS di link public.</li>
                <li>Setelah ubah pengaturan, buat invoice baru untuk melihat hasil PDF.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InvoicePageHeader from '@/components/invoice/InvoicePageHeader.vue';
import '@/assets/invoice-module.css';
import {
  applyInvoiceShortcodes,
  whatsAppTextToPreviewHtml,
  FALLBACK_SHORTCODES,
  FALLBACK_DEFAULT_WA,
  FALLBACK_DEFAULT_EMAIL_SUBJECT,
  FALLBACK_DEFAULT_EMAIL_HTML
} from '@/utils/invoiceTemplatePreview';

export default {
  components: { InvoicePageHeader },
  data() {
    return {
      form: {
        starqris_enabled: 0,
        default_device_id: null,
        wa_template: '',
        email_subject: '',
        email_body_html: '',
        mailketing_api_token: '',
        mailketing_from_email: '',
        mailketing_from_name: '',
        company_name: '',
        company_address: '',
        company_phone: '',
        starqris_api_key: '',
        starqris_webhook_secret: '',
        starqris_qris_account_id: '',
        bank_accounts: [{ bank_name: '', bank_account_number: '', bank_account_holder: '' }],
        manual_transfer_notes: ''
      },
      starqrisBool: false,
      manualTransferBool: true,
      webhookUrl: '',
      testEmail: '',
      saving: false,
      notifyChannel: 'wa',
      waMode: 'edit',
      emailMode: 'edit',
      activeShortcodeTarget: 'wa',
      templateMeta: {},
      shortcodes: FALLBACK_SHORTCODES
    };
  },
  computed: {
    defaultWA() {
      return this.templateMeta.default_wa || FALLBACK_DEFAULT_WA;
    },
    defaultEmailSubject() {
      return this.templateMeta.default_email_subject || FALLBACK_DEFAULT_EMAIL_SUBJECT;
    },
    defaultEmailHtml() {
      return this.templateMeta.default_email_html || FALLBACK_DEFAULT_EMAIL_HTML;
    },
    effectiveWATemplate() {
      const t = (this.form.wa_template || '').trim();
      return t || this.defaultWA;
    },
    effectiveEmailSubject() {
      const t = (this.form.email_subject || '').trim();
      return t || this.defaultEmailSubject;
    },
    effectiveEmailHtml() {
      const t = (this.form.email_body_html || '').trim();
      return t || this.defaultEmailHtml;
    },
    waPreviewHtml() {
      const text = applyInvoiceShortcodes(this.effectiveWATemplate, this.form);
      return whatsAppTextToPreviewHtml(text);
    },
    emailPreviewSrcdoc() {
      const html = applyInvoiceShortcodes(this.effectiveEmailHtml, this.form);
      const subj = applyInvoiceShortcodes(this.effectiveEmailSubject, this.form);
      return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${this.escapeAttr(subj)}</title></head><body style="margin:0">${html}</body></html>`;
    },
    previewTimeLabel() {
      const d = new Date();
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    }
  },
  mounted() {
    axios.get('invoice/settings').then(r => {
      const s = r.data.data.setting || {};
      const meta = r.data.data.template_meta || {};
      this.templateMeta = meta;
      if (Array.isArray(meta.shortcodes) && meta.shortcodes.length) {
        this.shortcodes = meta.shortcodes;
      }
      this.webhookUrl = r.data.data.webhook_url || '';
      Object.assign(this.form, {
        default_device_id: s.default_device_id,
        wa_template: s.wa_template || '',
        email_subject: s.email_subject || '',
        email_body_html: s.email_body_html || '',
        mailketing_from_email: s.mailketing_from_email || '',
        mailketing_from_name: s.mailketing_from_name || '',
        company_name: s.company_name || '',
        company_address: s.company_address || '',
        company_phone: s.company_phone || '',
        starqris_qris_account_id: s.starqris_qris_account_id || '',
        manual_transfer_notes: s.manual_transfer_notes || ''
      });
      this.form.bank_accounts = this.normalizeBanksFromSetting(s);
      this.starqrisBool = s.starqris_enabled == 1;
      this.manualTransferBool = s.manual_transfer_enabled == null || s.manual_transfer_enabled == 1;
    }).catch(e => {
      this.$toast.error(e.response?.data?.message || 'Gagal memuat pengaturan invoice');
    });
  },
  methods: {
    escapeAttr(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    },
    insertShortcode(target, code) {
      const map = {
        wa: 'waTemplateInput',
        html: 'emailHtmlInput',
        subject: 'emailSubjectInput'
      };
      const refName = map[target] || map.wa;
      const el = this.$refs[refName];
      if (!el) return;
      const input = el.$el || el;
      const start = input.selectionStart != null ? input.selectionStart : (this.form[refName === 'emailSubjectInput' ? 'email_subject' : refName === 'emailHtmlInput' ? 'email_body_html' : 'wa_template'] || '').length;
      const end = input.selectionEnd != null ? input.selectionEnd : start;
      const field = refName === 'emailSubjectInput' ? 'email_subject' : refName === 'emailHtmlInput' ? 'email_body_html' : 'wa_template';
      const val = this.form[field] || '';
      this.form[field] = val.slice(0, start) + code + val.slice(end);
      this.$nextTick(() => {
        input.focus();
        const pos = start + code.length;
        if (input.setSelectionRange) input.setSelectionRange(pos, pos);
      });
    },
    resetWATemplate() {
      this.form.wa_template = this.defaultWA;
      this.waMode = 'edit';
      this.$toast.success('Template WhatsApp bawaan dimuat');
    },
    resetEmailTemplate() {
      this.form.email_subject = this.defaultEmailSubject;
      this.form.email_body_html = this.defaultEmailHtml;
      this.emailMode = 'edit';
      this.$toast.success('Template email bawaan dimuat');
    },
    emptyBank() {
      return { bank_name: '', bank_account_number: '', bank_account_holder: '' };
    },
    addBankAccount() {
      this.form.bank_accounts.push(this.emptyBank());
    },
    normalizeBanksFromSetting(s) {
      const list = s.bank_accounts;
      if (Array.isArray(list) && list.length) {
        return list.map(b => ({
          bank_name: b.bank_name || '',
          bank_account_number: b.bank_account_number || '',
          bank_account_holder: b.bank_account_holder || ''
        }));
      }
      if (s.bank_name || s.bank_account_number || s.bank_account_holder) {
        return [{
          bank_name: s.bank_name || '',
          bank_account_number: s.bank_account_number || '',
          bank_account_holder: s.bank_account_holder || ''
        }];
      }
      return [this.emptyBank()];
    },
    save() {
      this.saving = true;
      this.form.starqris_enabled = this.starqrisBool ? 1 : 0;
      this.form.manual_transfer_enabled = this.manualTransferBool ? 1 : 0;
      axios.post('invoice/settings', this.form)
        .then(() => this.$toast.success('Pengaturan tersimpan'))
        .catch(e => this.$toast.error(e.response?.data?.message || 'Gagal'))
        .finally(() => { this.saving = false; });
    },
    testMail() {
      if (!this.testEmail) {
        this.$toast.error('Isi email tujuan test');
        return;
      }
      axios.post('invoice/settings/test-email', { to: this.testEmail })
        .then(() => this.$toast.success('Test email dalam antrian'))
        .catch(e => this.$toast.error(e.response?.data?.message || 'Gagal'));
    }
  }
};
</script>
